<template>
<VanPopup
  :show="visible"
  closeable
  position="bottom"
  :style="{ height: '65vh' }"
  @close="handlePopupClose"
>
  <p class="title-rule">Free Shipping</p>

  <div class="rule-content">
    <p class="promotion-desc" v-html="freeShippingPromotion?.copyWriting || ''" />
  </div>
</VanPopup>
</template>

<script setup lang="ts">
defineProps<{ visible: boolean, freeShippingPromotion?: ProductV2.IFreeShippingPromotion }>()

const emit = defineEmits<{ (e: 'update:visible', value: boolean):void }>()

const handlePopupClose = () => {
  emit('update:visible', false)
}
</script>

<style lang="scss" scoped>
.title-rule{
  text-align: center;
  font-size: 26px;
  font-weight: 600;
  margin: 30px 0;
}
.rule-content{
  padding: 20px;
}
.promotion-title{
  margin-bottom: 30px;
}
.promotion-desc{
  font-size: 24px;
  line-height: 32px;
  white-space: pre-wrap;
}
</style>